import React, { useEffect } from 'react';
import { Dispatch, bindActionCreators } from 'redux';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { RootState } from '../../reducers';
import * as actions from '../../actions/generalActions';
import { Switch, Route } from 'react-router-dom';
import "./Installation.scss";
import { withRouter } from 'react-router';
import InstallationListPage from './InstallationListPage';
import InstallationDetail from './InstallationDetail';
import InstallationForm from './InstallationForm';
import InstallationWithoutForm from './InstallationWithoutForm';
import Archive from "../Archive/Archive";
import Page404 from "../Page404";

// Keep old components for backward compat if needed
import AllInstallationRecords from "./AllInstallationRecords";
import CreateInstallationForm from "./CreateInstallationForm";
import AllProjectForInstallationMap from "./AllProjectForInstallationMap";

interface Props {
    intl: any;
    actions: any;
    history: any;
}

const Installation = (props: Props) => {
    useEffect(() => {
        props.actions.getUserPermissionsAndResponsibilities();
    }, []);

    return (
        <div className="installation inside-container">
            <Switch>
                <Route exact path="/dashboard/installation" component={InstallationListPage} />
                <Route exact path="/dashboard/installation/create" component={InstallationForm} />
                <Route exact path="/dashboard/installation/create-without-installation" component={InstallationWithoutForm} />
                <Route path="/dashboard/installation/archive/:moduleName?" component={Archive} />
                {/* Legacy routes */}
                <Route exact path="/dashboard/installation/records/:query?" component={AllInstallationRecords} />
                <Route exact path="/dashboard/installation/map/records" component={AllProjectForInstallationMap} />
                <Route exact path="/dashboard/installation/create-legacy/:transportId?" component={CreateInstallationForm} />
                {/* New detail route */}
                <Route exact path="/dashboard/installation/:installationId" component={InstallationDetail} />
                <Route render={() => <Page404 />} />
            </Switch>
        </div>
    );
};

function mapStateToProps(state: RootState, ownProps: any) {
    return {
        ...ownProps,
        ...state.app,
    };
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
    return {
        actions: bindActionCreators(actions as any, dispatch),
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(Installation as any)));
